import { render } from "./CereriDocumente.vue?vue&type=template&id=a4c8a38e&ts=true"
import script from "./CereriDocumente.vue?vue&type=script&lang=ts"
export * from "./CereriDocumente.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__